// extracted by mini-css-extract-plugin
export default {"icon":"tickets-table_icon__tSipi","tooltipClass":"tickets-table_tooltipClass__71WaJ"};